import React, {useState} from 'react';
import './addProjectPopups.scss';
import {request} from "../../../../api/request";

const DeleteProjectPopup = ({ onClose, fetchMatrix, toDelete}) => {
    const [message, setMessage] = useState(null);
    const [messageType, setMessageType] = useState("");

    const handlesend = async (data) => {
        await request
            .delete(
                `/donors/matrixaction/delete/${data.id}`,
                {
                    headers: {
                        "api-token": "p12378",
                        "Authorization" : `Bearer ${localStorage.getItem("dToken")}`
                    }
                }
            )
            .then((res) => {
                setMessage("Deleted successfully!");
                setMessageType("success");
                fetchMatrix()
                setTimeout(() => {
                    onClose();
                }, 2000);
            })
            .catch((err) => {
                setMessage(err.response?.data?.message || "An unknown error occurred.!");
                setMessageType("error");
                console.log(err)
            });
    }
    const handleSubmit = (e) => {
        e.preventDefault();
        handlesend(toDelete)
    };

    return (
        <div className="modal-overlay">
            <div className="modal-content" style={{width: '400px'}}>
                <button className="closer-btn" onClick={()=>onClose()}>&times;</button>
                <h2>Do you really want to delete information about the {toDelete.project_title || "project"}?</h2>

                <form onSubmit={handleSubmit}>
                    <div className="action-buttons">
                        <button type="submit" >Delete</button>
                        <button type="button" onClick={onClose}>Cancel</button>
                    </div>

                </form>
                {message && (
                <div className={`message ${messageType}`}>
                    {message}
                </div>
            )}
            </div>
        </div>
    );
};

export default DeleteProjectPopup;

